import validate from 'validate.js'

const constraints = {
  invoiceId: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
